/**
 * BoostDE - ajout au panier depuis les sections custom, branche sur le tiroir panier Horizon.
 * - Le tiroir s'ouvre immediatement au clic (etat de chargement discret), puis se remplit.
 * - Le bouton affiche un spinner pendant l'ajout, puis un etat "ajoute" vert.
 * - Declenche le meme evenement que le formulaire produit natif (CartLinesUpdateEvent).
 * - Corrige aussi le zoom automatique d'iOS sur les champs (texte a 16px minimum sur mobile).
 */
import { CartLinesUpdateEvent } from '@shopify/events';

if (!document.getElementById('dh-cart-ux')) {
  const s = document.createElement('style');
  s.id = 'dh-cart-ux';
  s.textContent = `
    @media (max-width: 749px) { input:not([type=checkbox]):not([type=radio]):not([type=submit]):not([type=button]):not([type=hidden]), select, textarea { font-size: 16px !important; } }
    @keyframes dh-spin { to { transform: rotate(360deg); } }
    @keyframes dh-bar { 0% { transform: translateX(-100%); } 100% { transform: translateX(250%); } }
    @keyframes dh-done { 0% { transform: scale(1); } 40% { transform: scale(1.04); } 100% { transform: scale(1); } }
    [data-dh-state] { opacity: 1 !important; transition: background .25s ease, box-shadow .25s ease; }
    [data-dh-state="loading"] { cursor: progress !important; }
    [data-dh-state="loading"]::before { content: ''; display: inline-block; width: 14px; height: 14px; margin-right: 8px; vertical-align: -2px; border: 2px solid rgba(255,255,255,.45); border-top-color: #fff; border-radius: 50%; animation: dh-spin .7s linear infinite; }
    [data-dh-state="done"] { background: #16a34a !important; box-shadow: 0 6px 18px rgba(22,163,74,.3) !important; animation: dh-done .35s ease; }
    #cart-drawer .cart-drawer__inner { position: relative; }
    #cart-drawer.dh-busy .cart-drawer__inner > * { opacity: .45; transition: opacity .2s ease; pointer-events: none; }
    #cart-drawer.dh-busy .cart-drawer__inner::before { content: ''; position: absolute; z-index: 5; top: 0; left: 0; width: 40%; height: 3px; background: linear-gradient(90deg, #1d4ed8, #06b6d4); animation: dh-bar .9s ease-in-out infinite; }
    @media (prefers-reduced-motion: reduce) { [data-dh-state]::before, #cart-drawer.dh-busy .cart-drawer__inner::before, [data-dh-state="done"] { animation: none; } }
  `;
  document.head.appendChild(s);
}

const cartUrl = () => (window.Theme && Theme.routes && Theme.routes.cart_url) || '/cart';
const addUrl = () => (window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add';

function openDrawer(drawer) {
  try { if (!drawer.isOpen && typeof drawer.open === 'function') drawer.open(); } catch (e) {}
}

function setState(el, state) {
  if (!el) return;
  if (state) el.dataset.dhState = state; else delete el.dataset.dhState;
}

async function add(source, items) {
  const comps = [...document.querySelectorAll('cart-items-component')];
  const sectionIds = comps.map((c) => c.dataset.sectionId).filter(Boolean);
  const drawer = document.getElementById('cart-drawer');

  setState(source, 'loading');

  // Pas de tiroir panier sur la page : on retombe sur la page panier
  if (!comps.length || !drawer) {
    const res = await fetch(addUrl() + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items }),
    });
    if (!res.ok) { setState(source, null); throw new Error('add failed'); }
    window.location.href = cartUrl();
    return;
  }

  // Ouverture immediate du tiroir, avec barre de chargement pendant la mise a jour
  drawer.classList.add('dh-busy');
  if (customElements.get('theme-drawer')) openDrawer(drawer);

  const deferred = CartLinesUpdateEvent.createPromise();
  source.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines: items.map((i) => ({ merchandiseId: String(i.id), quantity: i.quantity })),
      promise: deferred.promise,
    })
  );

  try {
    const res = await fetch(addUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items, sections: sectionIds.join(',') }),
    });
    const data = await res.json();
    await customElements.whenDefined('cart-items-component');
    const cart = await comps[0].fetchCartData();
    const failed = Boolean(data.status);
    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: {
        items: cart.items,
        source: 'boostde-section',
        itemCount: items.reduce((s, i) => s + i.quantity, 0),
        sections: data.sections,
        didError: failed,
      },
    });
    if (failed) throw new Error(data.description || data.message || 'add failed');

    await customElements.whenDefined('theme-drawer');
    openDrawer(drawer);
    setState(source, 'done');
    setTimeout(() => setState(source, null), 1500);
  } catch (e) {
    setState(source, null);
    deferred.reject(e);
    throw e;
  } finally {
    // Laisse le temps au tiroir de se re-rendre avant de retirer l'etat de chargement
    requestAnimationFrame(() => requestAnimationFrame(() => drawer.classList.remove('dh-busy')));
  }
}

window.BoostCart = { add };
